import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { TreeviewConfig, TreeviewItem } from '@ingenmaffen/ngx-treeview';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { AppState, TagChanges } from '../../app.models';
import { selectClientId, selectTreeView } from '../../app.selector';

@Component({
  selector: 'app-tag-select',
  templateUrl: './tag-select.component.html',
  styleUrls: ['./tag-select.component.scss']
})
export class TagSelectComponent implements OnInit, OnChanges, OnDestroy {
  $clientId: Observable<string>;
  items: TreeviewItem[];
  config: TreeviewConfig;
  @Input() selected: number[];
  @Input() disableGroupSelect: boolean;
  @Output() changes: EventEmitter<TagChanges[]> = new EventEmitter();
  delta: TagChanges[] =[];
  groupIds: number[];
  items$: Subscription;
  groupIds$: Subscription;

  constructor(
    private store: Store
  ) {
    this.config = TreeviewConfig.create({
      hasAllCheckBox: false,
      hasCollapseExpand: false,
      hasFilter: true,
      maxHeight: 2000,
      decoupleChildFromParent: true
    });
  }

  ngOnInit(): void {
    this.$clientId = this.store.select(selectClientId);

    this.items$ = this.store.select(selectTreeView)
      .subscribe((tags: TreeviewItem[]) => {
        this.items = tags;
      });

      this.groupIds$ = this.store.select((state:AppState)=>state.tags.filter(t=>t.group))
      .subscribe(tags=>this.groupIds=tags.map(t=>t.id));
  }
  ngOnChanges(changes) {
    const {currentValue, previousValue} =  changes.selected;
    if (currentValue && previousValue && currentValue.sort().toString() !== previousValue.sort().toString()) {
      this.delta=[];
    }
  }

  select(item, e) {
    this.delta = this.delta.filter(c=>c.tagid!==item.value);
    if (e.target.checked && !this.selected.includes(item.value)) {
      this.delta.push({tagid:item.value, action:'add'});
    } else if (!e.target.checked && this.selected.includes(item.value)) {
      this.delta.push({tagid:item.value, action:'delete'});
    }
    this.changes.emit(this.delta);
  }

  ngOnDestroy () {
    this.items$.unsubscribe();
    this.groupIds$.unsubscribe();
  }
}
